import { Box, IconButton } from '@mui/material';
import { FC, useState } from 'react';
import { Theme } from '../../../styles/theme/theme';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import SmileFaceAi from '../../../icons/smiley_ai_blue.png';
import SmileFaceAiGif from '../../../icons/smiley_ai_blue.gif';

export const AiBigButton: FC<IAiBigButton> = ({ show, onOpenAIAssistant, onShowAISmallButton }) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  return (
    <Box
      sx={{
        position: 'absolute',
        zIndex: 9999,
        right: '34px',
        bottom: '40px',
        width: '80px',
        height: '80px',
        padding: '10px',
        cursor: 'pointer',
        visibility: show ? 'visible' : 'hidden',
        '&:hover > button': {
          visibility: show ? 'visible' : 'hidden',
        },
      }}
    >
      <Box
        onClick={onOpenAIAssistant}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        sx={{
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          border: `1px solid ${Theme.palette.divider}`,
          background: Theme.palette.background.default,
        }}
      >
        <img
          src={isHovered ? SmileFaceAiGif : SmileFaceAi}
          alt={t('aiAssistant.title')}
          style={{
            width: '60px',
            height: '60px',
          }}
        />
      </Box>
      <IconButton
        sx={{
          position: 'absolute',
          top: '0px',
          right: '-7px',
          padding: 0,
          visibility: 'hidden',
        }}
        title={t('common.close')}
        onClick={onShowAISmallButton}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

interface IAiBigButton {
  onOpenAIAssistant: () => void;
  onShowAISmallButton: () => void;
  show: boolean;
}
